import { motion } from "framer-motion";

const testimonials = [
  {
    quote:
      "We onboarded NB Security Services for our downtown Saint John tower after two failed relationships with national firms. The difference is discipline. Our tenants finally feel safe.",
    author: "Property Director",
    org: "Uptown Commercial Portfolio · Saint John",
  },
  {
    quote:
      "84 officers, three days, zero incidents. Their event operations plan for our Moncton festival was more detailed than anything we'd seen from far larger companies.",
    author: "Festival Producer",
    org: "Cultural Foundation · Moncton",
  },
  {
    quote:
      "Their construction team caught two attempted copper thefts in our first month at the Fredericton hospital expansion. The mobile CCTV tower paid for the entire contract.",
    author: "Senior Project Manager",
    org: "General Contractor · Fredericton",
  },
];

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials"
      className="relative border-t border-border bg-[hsl(0_0%_5%)]"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 py-24 md:py-32">
        <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-muted-foreground mb-6">
          [ 06 · Field Reports ]
        </div>
        <h2 className="font-serif font-light text-4xl md:text-7xl leading-[0.95] tracking-tighter mb-16 max-w-4xl">
          What Our <br />
          <i className="text-primary">Clients</i> Say.
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 border-t border-l border-border">
          {testimonials.map((t, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{
                duration: 0.7,
                delay: i * 0.1,
                ease: [0.76, 0, 0.24, 1],
              }}
              className="border-r border-b border-border p-10 md:p-12 flex flex-col justify-between min-h-[380px]"
            >
              <div>
                <div className="font-serif text-6xl text-primary leading-none mb-6">
                  &ldquo;
                </div>
                <p className="font-serif italic text-xl md:text-2xl leading-snug text-foreground/90">
                  {t.quote}
                </p>
              </div>
              <div className="mt-8 pt-6 border-t border-border">
                <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-primary mb-1">
                  {t.author}
                </div>
                <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-muted-foreground">
                  {t.org}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
